<template>
  <div class="operation_log" style="background-color: #FFFFFF;">
    <div class="fixed_search">
      <div class="fixed_search_input">
        <Input v-model="operationName" placeholder="请输入操作人员" title="操作人员"/>
      </div>
      <div class="fixed_search_input">
        <Input v-model="operationTitle" placeholder="请输入操作标题" title="操作标题" />
      </div>
      <div class="fixed_search_input">
        <Input v-model="journalIp" placeholder="请输入操作IP" title="操作标题" />
      </div>
      <div class="fixed_operation_btn">
        <Button type="primary" class="search_btn" @click="initSearch">查询</Button>
      </div>
    </div>
    <div class="fixed_table">
      <Spin size="large" fix v-if="spinShow"> <Icon type="ios-loading" size=18 class="demo-spin-icon-load"></Icon><div>正在加载中...</div></Spin>
      <div class="table_head">
        <table>
          <tr>
            <th class="font_style_set" style="width:5%;">序号</th>
            <th class="font_style_set" style="width:18%;">操作人员</th>
            <th class="font_style_set" style="width:23%;">操作标题</th>
            <th class="font_style_set" style="width:15%;">操作IP</th>
            <th class="font_style_set" style="width:21%;">备注</th>
            <th class="font_style_set" style="width:18%;">操作时间</th>
          </tr>
        </table>
      </div>
      <div style="border-bottom: 1px solid rgb(235, 238, 245);" class="footer_style" :style="tableHeight">
        <table class="table_head_footer">
          <tr v-for="(item , index) in infoTableList" :key="index" :id="item.id" :class="{back_color:(index+1)%2==0}">
            <td  style="width:5%;">{{index+1}}</td>
            <td  style="width:18%;">{{item.employeeCode}}</td>
            <td  style="width:23%;" :title="item.journalType">{{item.journalType}}</td>
            <td  style="width:15%;">{{item.journalIp}}</td>
            <td  style="width:21%;" :title="item.journalDescr">{{item.journalDescr}}</td>
            <td  style="width:18%;">{{item.journalTime}}</td>
          </tr>
        </table>
      </div>
      <div class="page_style">
        <Page :total="total" size="small" :page-size='pageSize' :current='currentPage' :page-size-opts="pageSizeList" show-total show-sizer  @on-change="changeCurrent" @on-page-size-change="changeSize"/>
        <div style="padding-top: 2px;">跳至</div><Input class="show-elevator" v-model="speedChangePage" @on-blur="handleCurrentPage"/><div style="padding-top: 2px;">页</div>
      </div>
    </div>
  </div>
</template>

<script>
    import {publicFunClass} from '@/components/js/PublicFunClass.js'
    export default {
      name: "OperationLog",
      mixins:[publicFunClass],
      props:{
        pageCode:String
      },
      data(){
        return{
          journalIp:'',
          showPageCount:0,
          operationName:'',
          operationTitle:'',
          tableHeight:{height:''},
          total:0,
          spinShow:true,
          pageSizeList:[10,20,30,40,50,100,200],
          speedChangePage: 1,
          currentPage:1,
          pageSize:20,
          infoTableList:[],
          configInfo: JSON.parse(localStorage.getItem("configInfo")),
        }
      },
      methods:{
        initSearch:function () {
          this.spinShow=true;
          let that=this;
          let param={
            employeeCode:this.operationName,
            journalType:this.operationTitle,
            journalIp:this.journalIp,
            pageNum:this.currentPage,
            pageSize:this.pageSize
          };
          this.$http.post("journalRecord/toIndex.json",param) .then(function (res) {
            that.spinShow=false;
            let result=res.data.flag;
            if(result!="666"){
              that.$Modal.info({
                title:'提示',
                content:res.data.msg
              });
              return false;
            }
            that.infoTableList=res.data.obj.list.content;
            that.total=res.data.obj.list.totalSize;
          })
        }
      },
      created(){
        this.tableHeight.height=this.mountHeight(225);
      },
      watch:{
        pageCode:function () {
          if(this.pageCode=='3_4' && this.showPageCount==0){
            this.showPageCount++;
            this.initSearch();
          }
        }
      }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/systemSetup/OperationLog.vue